import { collection, doc, getDoc, getDocs, setDoc, updateDoc } from 'firebase/firestore';
import { IRouteDetails } from '../sp-types/routeDetailsType';
import { db } from './firebase';

const ROUTE_DETAILS_COLLECTION_NAME = 'route-details';
const DB_LOCATION = db;

export async function createRouteDetails(
  data: IRouteDetails,
  routeId: string,
  callback?: (success: boolean, createdObject?: IRouteDetails) => void,
) {
  try {
    const docRef = doc(DB_LOCATION, ROUTE_DETAILS_COLLECTION_NAME, routeId);
    await setDoc(docRef, data);
    const docSnap = await getDoc(docRef);
    const routeDetails = docSnap.data() as IRouteDetails;
    routeDetails.id = docSnap.id;
    return routeDetails;
  } catch (err) {
    console.log(`Error creating Route details: ${err}`);
    callback && callback(false);
  }
}

export async function getRoutesDetailsByIds(routeIds: string[]): Promise<IRouteDetails[]> {
  try {
    const routes: IRouteDetails[] = [];
    for (const routeId of routeIds) {
      const docRef = doc(DB_LOCATION, ROUTE_DETAILS_COLLECTION_NAME, routeId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const route = docSnap.data() as IRouteDetails;
        route.id = docSnap.id;
        routes.push(route);
      }
    }
    return routes;
  } catch (err) {
    console.log(`Error getting routes by IDs: ${err}`);
    return [];
  }
}

export async function getAllRouteDetailsIds(): Promise<string[]> {
  const routesRef = collection(DB_LOCATION, ROUTE_DETAILS_COLLECTION_NAME);
  try {
    const querySnapshot = await getDocs(routesRef);
    const routeIds = querySnapshot.docs.map((doc) => doc.id);
    return routeIds;
  } catch (err) {
    console.log(`Error getting route IDs: ${err}`);
    return [];
  }
}

export async function updateRouteDetail(
  routeId: string,
  updatedData: Partial<IRouteDetails>,
  callback?: (success: boolean, updatedObject?: IRouteDetails) => void,
) {
  try {
    console.log(updatedData);
    const docRef = doc(DB_LOCATION, ROUTE_DETAILS_COLLECTION_NAME, routeId);
    await updateDoc(docRef, updatedData);
    const docSnap = await getDoc(docRef);
    const routeDetails = docSnap.data() as IRouteDetails;
    routeDetails.id = docSnap.id;
    callback && callback(true, routeDetails);
    return routeDetails;
  } catch (err) {
    console.log(`Error updating Route details: ${err}`);
    callback && callback(false);
  }
}
